import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutTariffLookup extends Layout {
    sourceTariffLookup: DataSource;
    tableTariff: Table;
}
